import quadrosArena from '../../shared/assets/quadrados-arena.png';
import quadrosStartup from '../../shared/assets/quadrados-startup.png';
import quadrosUrbano from '../../shared/assets/quadrados-urbano.png';

import homenArena from '../../shared/assets/homen-arena.png';
import homenRural from '../../shared/assets/homen-rural.png';
import mulherUrbano from '../../shared/assets/mulher-empretec.png';
import mulherStartup from '../../shared/assets/mulher-startup.png';

export const INTERVIEW_STEPS = [
  {
    title: 'Vídeo',
    isClickable: false,
  },
  {
    title: 'Termos e Condições',
    isClickable: false,
  },
  {
    title: 'Dados Cadastrais',
    isClickable: false,
  },
  {
    title: 'Recomendações para entrevista',
    isClickable: false,
  },
  {
    title: 'Entrevista',
    isClickable: false,
  },
];

export const INTERVIEW_STEPS_STARTUP = [
  {
    title: 'Vídeo',
    isClickable: false,
  },
  {
    title: 'Termos e Condições',
    isClickable: false,
  },
  {
    title: 'Dados Cadastrais',
    isClickable: false,
  },
  {
    title: 'Questionário',
    isClickable: false,
  },
];

export const QUESTION_TIPS = [
  {
    id: 1,
    frases: [
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'O que pensava realizar?',
      'Falou com alguém sobre o que estava por fazer?',
      'Caso positivo, o que conversaram?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
  {
    id: 2,
    frases: [
      'Quem mais estava envolvido?',
      'O que você determinou que fizessem?',
      'Como você conseguiu que fizessem isso?',
      'O que você disse a ele(s)?',
      'Quais resultados obteve com o que determinou que fizessem?',
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'Falou com alguém sobre o que estava por fazer?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
  {
    id: 3,
    frases: [
      'Qual a dificuldade da situação?',
      'Encontrou alternativa para tratar o problema?',
      'O que pensava durante esta situação?',
      'Que êxito considera ter alcançado por superar este problema?',
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'O que pensava realizar?',
      'Falou com alguém sobre o que estava por fazer?',
      'Caso positivo, o que conversaram?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
  {
    id: 4,
    frases: [
      'O que mais lhe orgulhou por ter conseguido isto?',
      'Houve outra coisa importante que você fez nesta situação?',
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'O que pensava realizar?',
      'Falou com alguém sobre o que estava por fazer?',
      'Caso positivo, o que conversaram?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
  {
    id: 5,
    frases: [
      'Qual era o risco?',
      'O que pensava deste risco naquele momento?',
      'Voltaria a correr o risco?',
      'O que o levou a tomar esta decisão?',
      'Como começou a se envolver?',
      'O que pensava no começo?',
      'O que pensava realizar?',
      'Falou com alguém sobre o que estava por fazer?',
      'Caso positivo, o que conversaram?',
      'Estava incluindo mais alguém?',
      'Qual foi a sequência das coisas que realizou?',
      'Qual foi sua participação nisto?',
      'Qual o resultado alcançado?',
      'Teve alguma outra coisa importante que você fez?',
      'O que considera que alcançou?',
    ],
  },
];

export const MODULE_IMAGES = {
  1: mulherUrbano,
  2: mulherStartup,
  3: homenArena,
  4: mulherUrbano,
};

export const MODULE_SQUARES_IMAGES = {
  1: quadrosUrbano,
  2: quadrosStartup,
  3: quadrosArena,
  4: homenRural,
};

export const STEP_TEXTS = {
  1: 'Antes de começar, conheça o Empretec.',
  2: 'Antes de começar, leia os termos e condições.',
  3: 'confira seus dados de cadastro.',
  4: 'leia as recomendações para a sua entrevista.',
};

export const STEP_TEXTS_STARTUP = {
  1: 'Antes de começar, conheça o Empretec.',
  2: 'Antes de começar, leia os termos e condições.',
  3: 'confira seus dados de cadastro.',
  4: 'preencha o questionário.',
};

export const RESULT_BG_COLORS = {
  PROCESSING: '#FFC700',
  ERROR: '#F73450',
  SUCCESS: '#4FAD4F',
};
